import { pxToRem } from '../../../../utils';
export default (function (siteVars) {
  return {
    boxShadow: siteVars.shadowLevel2,
    borderRadius: pxToRem(3),
    borderSize: '1px',
    padding: "".concat(pxToRem(5), " ").concat(pxToRem(12), " ").concat(pxToRem(7), " ").concat(pxToRem(12)),
    maxWidth: pxToRem(246),
    pointerVerticalOffset: pxToRem(10),
    pointerHorizontalOffset: pxToRem(5),
    pointerMargin: pxToRem(6),
    pointerGap: pxToRem(5),
    pointerWidth: pxToRem(6),
    pointerHeight: pxToRem(16),
    color: siteVars.colorScheme["default"].foreground3,
    backgroundColor: siteVars.colors.grey[500],
    zIndex: siteVars.zIndexes.overlay
  };
});